import { apiClient } from './api';
import type { ApiResponse, PaginatedResponse } from '@/types';
import type { ChannelType } from './channelsService';

export interface Conversation {
  id: string;
  tenant_id: string;
  contact_id: string;
  channel: ChannelType;
  status: 'open' | 'closed';
  opened_at: string;
  closed_at?: string;
  last_message_at?: string;
  window_started_at?: string;
  window_expires_at?: string;
  last_message?: {
    id: string;
    conversation_id: string;
    direction: 'inbound' | 'outbound';
    type: 'text' | 'template';
    text?: string;
    template_id?: string;
    status?: 'queued' | 'sent' | 'delivered' | 'read' | 'failed';
    created_at: string;
  } | null;
  contacts?: {
    id: string;
    name?: string;
    phone: string;
    email?: string;
    tags: string[];
    opt_in: boolean;
  };
}

export interface ConversationMessage {
  id: string;
  conversation_id: string;
  tenant_id: string;
  direction: 'inbound' | 'outbound';
  channel: ChannelType;
  type: 'text' | 'template';
  text?: string;
  template_id?: string;
  status?: 'queued' | 'sent' | 'delivered' | 'read' | 'failed';
  created_at: string;
}

export interface ListConversationsParams {
  tenant_id?: string;
  channel?: ChannelType;
  status?: 'open' | 'closed';
  page?: number;
  limit?: number;
}

export async function listConversations(
  params?: ListConversationsParams
): Promise<ApiResponse<PaginatedResponse<Conversation>>> {
  return apiClient.getPaginated<Conversation>('/conversations', params);
}

export async function getConversation(conversationId: string): Promise<ApiResponse<Conversation>> {
  return apiClient.get<Conversation>(`/conversations/${conversationId}`);
}

export interface ListConversationMessagesParams {
  page?: number;
  limit?: number;
}

export async function listConversationMessages(
  conversationId: string,
  params?: ListConversationMessagesParams
): Promise<ApiResponse<PaginatedResponse<ConversationMessage>>> {
  return apiClient.getPaginated<ConversationMessage>(`/conversations/${conversationId}/messages`, params);
}
